import React from 'react';
import { Navbar, Nav, Button } from 'react-bootstrap';
import './Navbar.scss';
import Menu from '../img/Navbar/menu.svg';
/* eslint-disable react/prop-types */
export default function Header({ navColor, setShowModal, themeToggle, setShowMenu, walletAddress, navState }) {
    const state = window.location.search.split("=")[1];
    
    const [walletAddressPartOne, setWalletAddressPartOne] = React.useState('')
    const [walletAddressPartTwo, setWalletAddressPartTwo] = React.useState('')

    const customWalletAddress = () => {
        if (walletAddress) {
            setWalletAddressPartOne(walletAddress.slice(0, 4));
            setWalletAddressPartTwo(walletAddress.slice(-3));
        }
    }

    React.useEffect(() => {
        customWalletAddress();
    })
    
    return (
        <Navbar
            collapseOnSelect
            expand="lg"
            // bg={(!navColor && 'transparent') || 'primary'}
            variant="dark"
            className={`nav-border ${navColor ? 'nav-background' : 'nav-transparent-bg'} ${navState === 'lottery' ? 'load-split-image' : navState === 'whitelist' ? 'load-split-image' : navState === 'purchase' ? 'load-split-image' : 'not-load-split-image'}`}
            fixed="top">
            <div className="container" style={{ justifyContent: 'center' }}>
                <Navbar.Brand href="#Home">
                    <img src="/logo.png" alt="bgimg" className="img-mobile" />
                </Navbar.Brand>
                {/* <Navbar.Toggle
                    aria-controls="responsive-navbar-nav"
                    className="toggle-position navbar-toggler">
                    <span>
                        <img src={Menu} alt="menu" />
                    </span>
                </Navbar.Toggle> */}
                {/* <Navbar.Collapse id="responsive-navbar-nav"> */}
                <Nav className="ml-auto apply-connect-btn">
                    {/* On main branch this needs to be hidden */}

                    {/* <Nav.Link href="#deets">
                            <Button className="outline-btn btn-toggle" onClick={themeToggle}>
                                Theme toggle
                            </Button>
                        </Nav.Link> */}
                    {/* <Nav.Link href="#deets">
                        <Button className="outline-btn btn-animations-apply">Apply</Button>
                    </Nav.Link> */}
                    <Nav.Link href="#">
                        
                        { 
                            walletAddress && state === 'lottery' && <Button className="outline-btn btn-animations-apply btn-overflow"><span className="address-settings">{`Connected to ${walletAddressPartOne}..${walletAddressPartTwo}`}</span></Button>  
                        }

                        { 
                            walletAddress && state === 'purchase' && <Button className="outline-btn btn-animations-apply btn-overflow"><span className="address-settings">{`Connected to ${walletAddressPartOne}..${walletAddressPartTwo}`}</span></Button>  
                        }

                        { 
                            walletAddress && state === 'whitelist' && <Button className="outline-btn btn-animations-apply btn-overflow"><span className="address-settings">{`Connected to ${walletAddressPartOne}..${walletAddressPartTwo}`}</span></Button>  
                        }

                        {/* {!walletAddress && 
                        <Button
                            className="bg-btn btn-animations"
                            onClick={() => setShowModal(true)}>
                            Connect
                        </Button>
                        } */}

                        {/* {walletAddress && state === 'whitelist' &&
                        <Button
                            className="bg-btn btn-animations"
                            onClick={() => setShowModal(true)}>
                            Connect
                        </Button>
                        } */}

                        {/* 
                        // <Button
                        //     className="bg-btn btn-animations"
                        //     onClick={() => setShowModal(true)}>
                        //     Connect
                        // </Button>
                        */}
                    </Nav.Link>
                </Nav>
                <Button className="menu-btn-phone" onClick={() => setShowMenu(true)}>
                    <span>
                        <img src={Menu} alt="menu" />
                    </span>
                </Button>
                {/* On main branch this needs to be hidden */}
                {/* </Navbar.Collapse> */}
            </div>
        </Navbar>
    );
}
